import { createContext, useContext } from 'react';

const WebsiteSettingsContext = createContext();

export const useWebsiteSettingsContext = () => {
  const context = useContext(WebsiteSettingsContext);
  if (!context) {
    throw new Error(
      'useWebsiteSettingsContext must be used within a WebsiteSettingsContext.Provider'
    );
  }
  return context;
};

export default WebsiteSettingsContext;
